import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from "@angular/forms";
import {NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-secondary-button',
  templateUrl: './secondary-button.component.html',
  standalone: true,
  imports: [
    NgIf,
    RouterLink
  ],
  styleUrls: ['./secondary-button.component.scss']
})
export class SecondaryButtonComponent implements OnInit {

  @Input() text: string = '';
  @Input() icon: string = '';
  @Input() link: string = '';
  @Input() load: boolean = false;
  @Input() style:any;
  @Input() formControlItem: any;
  @Input() className: string = '';
  @Output() onClick: EventEmitter<boolean> = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
  }

  handleClick(): void {
    if(!this.load) {
      this.onClick.emit();
    }
  }



}
